import { render, staticRenderFns } from "./ClassroomZoomStartUrlModal.vue?vue&type=template&id=5547d1de&scoped=true"
import script from "./ClassroomZoomStartUrlModal.vue?vue&type=script&lang=js"
export * from "./ClassroomZoomStartUrlModal.vue?vue&type=script&lang=js"
import style0 from "./ClassroomZoomStartUrlModal.vue?vue&type=style&index=0&id=5547d1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547d1de",
  null
  
)

export default component.exports